var EICDataStream3UserAdmin = angular.module("EICDataStream3.userAdmin", [])
  .config(function () {
  });


angular.module('EICDataStream3.userAdmin')
  .controller("ChangePasswordController", ["changePasswordService",
    function (changePasswordService) {
      var vm = this;
      vm.oldPassword = "";
      vm.newPassword = "";
      vm.confirmNewPassword = "";
      vm.response={ failed:true, message: "" };
      vm.working = false;

      vm.changePassword = function() {
        // make an http call to  the api to  change the current user's password
        // on success, send back  a success message, else a failure message
        // which could be a server-side validation failure

        vm.working = true;
        vm.response={ failed:false, message: "" };
        changePasswordService.changePassword(vm.oldPassword, vm.newPassword, vm.confirmNewPassword)
          .then(function () {
            vm.working = false;
            vm.response = {
              failed:false,
              style: {color: "darkgreen", "font-size": "14px"},
              message: "Your password was successfully changed"
            };
        })
          .catch(function(errResponse, status, y, request){
            vm.working = false;
            vm.response = {
              failed:true,
              style: {color: "red", "font-size": "14px"},
              message: errResponse.message
            };
          });
      };

      return vm;
    }])
    .service("changePasswordService", ["$http",
      function($http){
        this.changePassword = function (oldPassword, newPassword, confirmNewPassword) {

          var data = {
            oldPassword: oldPassword,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword
          };

          return $http.post("/api/userAdmin/changePassword/", JSON.stringify(data));
        };
    }]);
